import axios from 'axios';

export default {
  getData() {
    return axios.get(`/modules/weblinks/`);
  },
  getSSOToken() {
    return axios.get(`/modules/weblinks/sso-token`);
  },
};
